import configureStore from 'store/configureStore';

const portalStore = configureStore();

export default portalStore;
